import Chart, {
  ArgumentAxis,
  CommonSeriesSettings,
  Label,
  Series,
} from "devextreme-react/chart";
import { formatConcept } from "../../../../utils/Numbers";
import dayjs from "dayjs";

const NetAssetValueChart = (props: any) => {
  const { netAssetValueChart, translations, loading, mainColor } = props;

  const customizePoint = (pointInfo: any) => {
    if (!pointInfo.data.quarter.includes("Q")) {
      return {
        color: mainColor
      };
    }
    return {};
  }

  const isAnyProforma = netAssetValueChart.some((item: any) => !item.quarter.includes("Q"));

  return (
    <div className="asset-value-chart">
      <h4>{translations.evolucionValorLiquidativo}</h4>
      <Chart
        dataSource={netAssetValueChart}
        palette={["#a8a6a6", "#dbdbdb"]}
        height={280}
        animation={true}
		customizePoint={customizePoint}
        argumentAxis={{
          tick: { visible: false },
        }}
        valueAxis={{
          visible: false,
          maxValueMargin: 0.05,
          grid: {
            visible: false,
          },
          showZero: true,
          tick: { visible: false },
          label: {
            visible: false,
          },
        }}
      >
        <CommonSeriesSettings argumentField="quarter" type="line" barWidth={50}>
          <Label
            visible={true}
            backgroundColor="none"
            font={{ color: "black", size: "10px" }}
            customizeText={(e) => {
              return formatConcept(e.value, 4);
            }}
          />
        </CommonSeriesSettings>
        <ArgumentAxis>
          <Label
            visible={true}
            font={{ color: "black", size: "10px" }}
            overlappingBehavior="hide"
			customizeText={(e) => {
			  return e.valueText.includes("Q") ? e.valueText : dayjs(e.valueText).format("DD/MM/YYYY");
			}}
          />
        </ArgumentAxis>
        <Series valueField="value" name={translations.valorLiquidativo} />
        {isAnyProforma && <Series name="Proforma" color={mainColor} />}
      </Chart>
      {netAssetValueChart.length === 0 && !loading && (
        <div className="no-data-found">{translations.noDataFound}</div>
      )}
    </div>
  );
};

export default NetAssetValueChart;
